import React from "react";
import cx from "classnames";

import {useLazyGetArticlesQuery} from "../../api/blog";

import styles from './Tag.module.scss';

type TagProps = {
    children: React.ReactNode;
    isActive?: boolean;
    count?: number;
    slug: string;
    onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
};

function Tag({children, isActive, count, slug, onClick}: TagProps) {

    const [ articlesRequest ] = useLazyGetArticlesQuery()

    const onClickTag = async (event: React.MouseEvent<HTMLDivElement>, slug: string) => {

        if (onClick) {
            onClick(event);
            return;
        }

        articlesRequest({
            category: slug,
        });

        // const articles = result.data?.data ?? [];
        //
        // const articleIds = articles.map((article) => article.id);
        //
        // if (articleIds.length > 0) {
        //     tagsRequest({ articleIds });
        // }
    }

    return (
        <div className={cx(styles.tag, {
            [styles.tagIsActive]: isActive,
        })} onClick={(e) => onClickTag(e, slug)}>
            {children}
            {count && <span className={styles.tagCount}>
                {count}
            </span>}
        </div>
    );
}

export default Tag;
